export function isOnboardingUrl(url) {
  return /^(meet.google)(\.com)?\/[A-Z]{3}-[A-Z]{4}-[A-Z]{3}/i.test(url)
}
